import { render, staticRenderFns } from "./dashboard-shared-index.vue?vue&type=template&id=413e50c3"
import script from "./dashboard-shared-index.vue?vue&type=script&lang=js"
export * from "./dashboard-shared-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports